import { constants } from '@yola/subscription-manager-js';
import {
  CUSTOM_DOMAIN,
  PREMIUM_COMPOSITE_GROUP,
  PUBLISHING,
  AI_LOCALIZATION,
  AI_BLOCK_GENERATION_QUOTA,
  AI_TEXT_ASSISTANT_QUOTA,
  UPLOAD_FILE_SIZE,
  BRANDED_HEADER,
  PASSWORD_PROTECTED_PAGES,
  PREMIUM_BLOCKS,
  ADVANCED_WEBSITE_CUSTOMIZATION,
  CUSTOM_CODE,
  PREMIUM_ICONS,
  PAGES_COUNT,
  FORM_ATTACHMENTS,
  MULTILINGUAL,
  SITE_BACKUPS,
} from '../constants/upsell-types';

const { hostingPackageFeatureNames } = constants;

const getHighlightedHostingPackageFeatures = (upsellType, hasDomainExtraPrice, details = {}) =>
  ({
    [CUSTOM_DOMAIN]: [
      {
        name: hostingPackageFeatureNames.CUSTOM_DOMAIN,
        position: details.isTrialDomainDiscountAvailable ? 3 : 2,
      },
      hasDomainExtraPrice && {
        name: hostingPackageFeatureNames.FREE_DOMAIN_PROMO,
        position: details.isTrialDomainDiscountAvailable ? 2 : 3,
      },
    ].filter(Boolean),
    [PUBLISHING]: [
      hasDomainExtraPrice &&
        !details?.isReactivatingSubscription && {
          name: hostingPackageFeatureNames.FREE_DOMAIN_PROMO,
          position: details.isTrialDomainDiscountAvailable ? 2 : 3,
        },
      {
        name: hostingPackageFeatureNames.CUSTOM_DOMAIN,
        position: details.isTrialDomainDiscountAvailable ? 3 : 2,
      },
    ].filter(Boolean),
    [PREMIUM_COMPOSITE_GROUP]: [
      {
        name: hostingPackageFeatureNames.PREMIUM_COMPOSITE_GROUP,
        position: 2,
      },
    ],
    [AI_LOCALIZATION]: [
      {
        name: hostingPackageFeatureNames.AI,
      },
      details.isAiLocalizationEnabled && {
        name: hostingPackageFeatureNames.AI_LOCALIZATION,
        position: 2,
      },
    ].filter(Boolean),
    [AI_BLOCK_GENERATION_QUOTA]: [
      {
        name: hostingPackageFeatureNames.AI,
        position: 1,
      },
      {
        name: hostingPackageFeatureNames.AI_BLOCK_GENERATOR,
        position: 2,
      },
    ],
    [AI_TEXT_ASSISTANT_QUOTA]: [
      {
        name: hostingPackageFeatureNames.AI,
        position: 1,
      },
      {
        name: hostingPackageFeatureNames.AI_TEXT_ASSISTANT,
        position: 2,
      },
    ],
    [UPLOAD_FILE_SIZE]: [
      {
        name: hostingPackageFeatureNames.UPLOAD_SIZE,
        position: 2,
      },
    ],
    [BRANDED_HEADER]: [
      {
        name: hostingPackageFeatureNames.PARTNER_ADS,
        position: 2,
      },
    ],
    [PASSWORD_PROTECTED_PAGES]: [
      {
        name: hostingPackageFeatureNames.PASSWORD_PROTECTED_PAGES,
        position: 2,
      },
    ],
    [PREMIUM_BLOCKS]: [
      {
        name: hostingPackageFeatureNames.PREMIUM_BLOCKS_AND_WIDGETS,
        position: 2,
      },
    ],
    [ADVANCED_WEBSITE_CUSTOMIZATION]: [
      {
        name: hostingPackageFeatureNames.ADVANCED_WEBSITE_CUSTOMIZATION,
        position: 2,
      },
    ],
    [CUSTOM_CODE]: [
      {
        name: hostingPackageFeatureNames.CUSTOM_CODE,
        position: 2,
      },
    ],
    [PREMIUM_ICONS]: [
      {
        name: hostingPackageFeatureNames.PREMIUM_ICONS_PAYWALL,
        position: 2,
      },
    ],
    [PAGES_COUNT]: [
      {
        name: hostingPackageFeatureNames.PAGE_COUNT,
        position: 2,
      },
    ],
    [FORM_ATTACHMENTS]: [
      {
        name: hostingPackageFeatureNames.FORM_ATTACHMENTS,
        position: 2,
      },
    ],
    [MULTILINGUAL]: [
      {
        name: hostingPackageFeatureNames.MULTILANGUAGE_SITE,
        position: 2,
      },
    ],
    [SITE_BACKUPS]: [
      {
        name: hostingPackageFeatureNames.UNLIMITED_SITE_BACKUPS,
        position: 2,
      },
    ],
  })[upsellType] || null;

export default getHighlightedHostingPackageFeatures;
